<template>
    <!-- Balení -->
    <section class="py-5 py-md-10 striped-section" v-if="!collectionFixed">
        <div class="container">
            <h2 class="title mb-4">{{$t('components.PackageSection.packaging')}}</h2>

            <div class="row">
                <div class="col-md-6">
                    <!-- Nefunguje mi thumber? -->
                    <!-- <img src="<?= \PHPView\getThumb('/images/bed1.jpg'); ?>" alt="" class="img-fluid"> -->
                    <img alt class="img-fluid" src="/images/bed1.jpg"/>
                </div>
                <div class="col-md-6">
                    <div class="small-title mb-3">{{$t('components.PackageSection.title')}}</div>
                    <p class="pr-lg-10">
                        {{$t('components.PackageSection.paragraph1')}}
                    </p>
                    <p class="pr-lg-10 mb-5">
                        {{$t('components.PackageSection.paragraph2')}}
                    </p>
                    <div class="cartRow">
                        <div class="cartRow__title">{{$t('components.PackageSection.premiumPacking')}}</div>
                        <div class="cartRow__price ml-auto">{{$t('common.free')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        computed: {
            collectionFixed: function () {
                return this.$store.state.configurator.collectionFixed;
            }
        }
    };
</script>
